/** Vinayaka Mission's Research Foundation — branded therapist login. */
export const VINAYAKA_MISSION_BRAND_NAME = "Vinayaka Mission's Research Foundation";

export const VINAYAKA_MISSION_LOGO_SRC = '/images/vinayaka-mission-logo.png';

export const VINAYAKA_MISSION_LOGIN_PATH = '/vmrf';

/** Optional: restrict login to users in this org (set in .env when known). */
export const VINAYAKA_MISSION_ORG_ID = (
  import.meta.env.VITE_VINAYAKA_MISSION_ORG_ID as string | undefined
)?.trim();

export const VINAYAKA_MISSION_POST_LOGIN_PATH = '/org-admin-dashboard';
